import React from "react";
import { MAIN_BUTTON } from "@constants";
import chatIcon from "@images/ic-chat.svg";
import {
    StyledCallToActionContainer,
    StyledTextContainer,
    StyledTitle,
    StyledDescription,
    StyledButtonContainer,
    StyledCallToActionButton
} from "./styled";

export default function CallToActionBanner({
    title,
    description,
    buttonText,
    buttonNavigationPath,
}) {
    return (
        <StyledCallToActionContainer>
            <StyledTextContainer>
                <StyledTitle>{title}</StyledTitle>
                <StyledDescription>{description}</StyledDescription>
            </StyledTextContainer>
            <StyledButtonContainer href={buttonNavigationPath}>
                <StyledCallToActionButton
                    text={buttonText}
                    type={MAIN_BUTTON}
                    bannerButtonIconPath={chatIcon}
                />
            </StyledButtonContainer>
        </StyledCallToActionContainer>
    );
}

CallToActionBanner.defaultProps = {
    title: "Would you like to catch up?",
    description:
        "Write to us in the chat and we will contact you within 24 hours",
    buttonText: "Say hello to our team",
    buttonNavigationTopic: "Product Development",
};
